import { DATE_FORMAT_API, DATE_PICKER_FORMAT } from '@constants/date';
import { format, isValid, parse } from 'date-fns';
import { outputDateValue } from './InputOutputDateFormat';

export const initFromToDates = () => {
  const _from = new Date();
  _from.setHours(0, 0, 0, 0);
  const _to = new Date(_from.getTime());
  _to.setDate(_to.getDate() + 1);
  const from = outputDateValue(_from);
  const to = outputDateValue(_to);
  return { from, to };
};

export const dateApiParser = (date: string): Date => {
  return parse(date, DATE_FORMAT_API, new Date());
};

export const datePickerParser = (date: string): Date => {
  return parse(date, DATE_PICKER_FORMAT, new Date());
};

export const FormatDateApiToString = (date: Date): string => {
  return format(date, DATE_FORMAT_API);
};

export const DateApiToDatePickerFormat = (date: string): string => {
  if (!isValid(dateApiParser(date))) return '';
  return format(dateApiParser(date), DATE_PICKER_FORMAT);
};

export const datePickerToDateApiFormat = (date: string) => {
  return format(datePickerParser(date), DATE_FORMAT_API);
};
